export enum Storage {
  STATE = 'GameState',
}

export default Storage;
